module.exports = require("./veci").exports.$;
